export default __webpack_public_path__ + "static/media/inverness-airport.77143d09.png";